import React from "react";
import styles from "./Navbar.module.scss";
import { useNavigate } from "react-router-dom";
import sprite from "../../assets/sprite.svg";
import useWindowSize from "../../hooks/useWindowSize";

function Navbar({
  placeholder = "Пошук за кодом",
  setGroup,
  mosaic,
  setSearch,
  terminate,

  setTerminate,
}) {
  const navigate = useNavigate();

  const size = useWindowSize();

  const onInputSearch = async (e) => {
    await setGroup("all");

    setTimeout(() => setSearch(e.target.value), 500);
  };
  return (
    <div
      className={styles.wrapper}
      // style={terminate ? undefined : { padding: "0 15px" }}
    >
      <button
        type="button"
        className={styles.backButton}
        style={
          terminate
            ? {
                marginLeft: size?.width < 768 ? "-15px" : 0,
                flexDirection: "row",
                justifyContent: "space-between",
                width: "71px",
                backgroundColor: "transparent",
                padding: 0,
              }
            : undefined
        }
        onClick={() => (terminate ? setTerminate(false) : navigate(-1))}
      >
        <div>
          <svg>
            <use href={sprite + "#icon-arrow-left"} />
          </svg>
        </div>
        <span>Назад</span>
      </button>
      {!(terminate || mosaic) && (
        <div className={styles.textField}>
          <span>
            <svg>
              <use href={sprite + "#icon-lens"} />
            </svg>
          </span>
          <input
            type="text"
            name="login"
            id="login"
            placeholder={placeholder}
            onInput={(e) => onInputSearch(e)}
          />
        </div>
      )}
    </div>
  );
}

export default Navbar;
